/* import __COLOCATED_TEMPLATE__ from './add-external-account.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { action, computed, set } from '@ember/object';
import { and } from '@ember/object/computed';
import { later } from '@ember/runloop';
import { scrollToFirstError } from '@square/ember-prism/utils/error-scrolling';
import validRoutingNumber from '@banking/ui/utils/valid-routing-number';
import { BankAccountType } from '@square/dashboard-protos/models/squareup/bank-accounts/bank_accounts';
let AddExternalAccount = (_dec = and('routingNumberValidation.isValid', 'accountNumberValidation.isValid', 'confirmAccountNumberValidation.isValid'), _dec2 = computed('routingNumber'), _dec3 = computed('accountNumber'), _dec4 = computed('confirmAccountNumber', 'accountNumber'), _class = class AddExternalAccount extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor2, this);
    _initializerDefineProperty(this, "sfsExternalBankAccountApi", _descriptor3, this);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "routingNumber", '');
    _defineProperty(this, "accountNumber", '');
    _defineProperty(this, "confirmAccountNumber", '');
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "accountTypeOptions", [{
      value: BankAccountType.CHECKING,
      label: this.intl.t('banking.enums.accounts.CHECKING')
    }, {
      value: BankAccountType.SAVINGS,
      label: this.intl.t('banking.enums.accounts.SAVINGS')
    }, {
      value: BankAccountType.BUSINESS_CHECKING,
      label: this.intl.t('banking.enums.accounts.BUSINESS_CHECKING')
    }]);
    _defineProperty(this, "accountType", this.accountTypeOptions[0].value);
    _initializerDefineProperty(this, "isValid", _descriptor4, this);
  }
  get routingNumberValidation() {
    const isValid = validRoutingNumber(this.routingNumber);
    return {
      isValid,
      isInvalid: !isValid,
      message: this.intl.t('sfs.shared.transfers.addBankAccount.routingNumberInvalid')
    };
  }
  get accountNumberValidation() {
    const isValid =
    // CorePro limits account numbers to a max of 17 digits
    this.accountNumber !== '' && this.accountNumber.match(/^\d{1,17}$/);
    return {
      isValid,
      isInvalid: !isValid,
      message: this.intl.t('sfs.shared.transfers.addBankAccount.accountNumberInvalid')
    };
  }
  get confirmAccountNumberValidation() {
    const isValid = this.confirmAccountNumber !== '' && this.accountNumber === this.confirmAccountNumber;
    return {
      isValid,
      isInvalid: !isValid,
      message: this.intl.t('sfs.shared.transfers.addBankAccount.confirmAccountNumberInvalid')
    };
  }
  async onSubmit() {
    if (this.isValid) {
      set(this, 'isLoading', true);
      try {
        const bankAccount = await this.sfsExternalBankAccountApi.linkExternalBankAccount({
          customerId: this.sfsCustomerApi.currentCustomer.id,
          primaryBankIdentificationNumber: this.routingNumber,
          accountNumber: this.accountNumber,
          accountType: this.accountType
        });
        this.selectBankAccount(bankAccount);
      } catch (error) {
        this.onLinkError(error);
      } finally {
        set(this, 'isLoading', false);
      }
    } else {
      // This is in a runloop because the error classes have not yet rendered
      later(() => {
        // Tests can remove the elements before `later` fires
        const modal = document.querySelector('.sfs-bank-selector__modal');
        if (modal) {
          scrollToFirstError(modal);
        }
      });
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sfsExternalBankAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isValid", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "routingNumberValidation", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "routingNumberValidation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "accountNumberValidation", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "accountNumberValidation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmAccountNumberValidation", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "confirmAccountNumberValidation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmit"), _class.prototype), _class);
export { AddExternalAccount as default };